import React from 'react'
import update from 'immutability-helper';

import UnitedStatesSelect from '../../helpers/General/UnitedStatesSelect';

import { phoneNumberFormatter } from '../../helpers/General/PhoneNunberFormatter'
import { ssnFormatter } from '../../helpers/General/SSNFormatter'
import { einFormatter } from '../../helpers/General/EINFormatter'
import { userBilling } from '../../core/controllers/UserBilling';
import { modal } from '../../core/utilities/modal';
import { user } from '../../core/controllers/user'

var valid = require('us-bank-account-validator');

export default class AccountReceivableForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            billingSetup : props.billingSetup,
            showForm: false,
            individualAccount: true,
            didSelectAccountType: false,
            customerData: {
                customer_streetAddress: '',
                customer_city: '',
                customer_state: 0,
                customer_name: '',
                customer_dba: user.userInfo.company,
                customer_phone: user.userInfo.phone,
                customer_postalCode: '',
                customer_tenantId: props.tenantID,
                customer_account_number: '',
                customer_routing_number: '',
                customer_bank_type: 8,
                customer_company_type: 0,
                customer_dob: '',
                customer_ein: '',
                customer_firstname: user.userInfo.firstname,
                customer_lastname: user.userInfo.lastname,
                customer_email: user.userInfo.username,
                customer_ownership: 0,
                customer_ssn: '',
                customer_businessWebsite: '',
                customer_ownerStreetAddress: '',
                customer_ownerCity: '',
                customer_ownerState: 0,
                customer_ownerPhone: '',
                customer_ownerPostalCode: '',
                customer_ownerTitle: ''
            }
        };
    }

    componentDidMount() {}

    componentWillUpdate(nextProps, nextState) {
    }

    handleSaveACH() {
        var self = this;
        const customerData = this.state.customerData;
        const individual = this.state.individualAccount;
        if(customerData.customer_firstname == '' || typeof customerData.customer_firstname == 'undefined') {
            modal.showInfo("We need to know the primary owner\'s firstname.", "warning", "top", "center");
            return;
        }
        if(customerData.customer_lastname == '' || typeof customerData.customer_lastname == 'undefined') {
            modal.showInfo("We need to know the primary owner\'s firstname.", "warning", "top", "center");
            return;
        }
        if(customerData.customer_email == '' || typeof customerData.customer_email == 'undefined') {
            modal.showInfo("We need to know the primary owner\'s email.", "warning", "top", "center");
            return;
        }
        if(customerData.customer_ownerStreetAddress == '' || typeof customerData.customer_ownerStreetAddress == 'undefined') {
            modal.showInfo("We need to know the primary owner\'s Address.", "warning", "top", "center");
            return;
        }
        if(customerData.customer_ownerCity == '' || typeof customerData.customer_ownerCity == 'undefined') {
            modal.showInfo("We need to know the primary owner\'s City.", "warning", "top", "center");
            return;
        }
        if(customerData.customer_ownerState == 0) {
            modal.showInfo("We need to know the primary owner\'s State.", "warning", "top", "center");
            return;
        }
        if(customerData.customer_ownerPostalCode == '' || typeof customerData.customer_ownerPostalCode == 'undefined') {
            modal.showInfo("We need to know the primary owner\'s Postal Code.", "warning", "top", "center");
            return;
        }
        if(!individual) {
            if(customerData.customer_ownership == 0 || typeof customerData.customer_ownership == 'undefined') {
                modal.showInfo("We need to know the primary owner\'s ownership of the company.", "warning", "top", "center");
                return;
            }
            if(customerData.customer_ownership > 100) {
                modal.showInfo("Please enter an ownership percentage between 1 and 100.", "warning", "top", "center");
                return;
            }
        }
        if(customerData.customer_phone == '' || typeof customerData.customer_phone == 'undefined') {
            modal.showInfo("We need to know the primary owner\'s phone number.", "warning", "top", "center");
            return;
        }
        if(customerData.customer_ssn == '' || typeof customerData.customer_ssn == 'undefined' || customerData.customer_ssn.length != 11) {
            modal.showInfo("We need to know the primary owner\'s social security number.", "warning", "top", "center");
            return;
        }
        if(customerData.customer_dob == '' || typeof customerData.customer_dob == 'undefined') {
            modal.showInfo("We need the primary account holder date of birth.", "warning", "top", "center");
            return;
        }
        if(customerData.customer_dba == '' || typeof customerData.customer_dba == 'undefined') {
            modal.showInfo("Are you doing business under another name?  Otherwise, re-enter the same name.", "warning", "top", "center");
            return;
        }
        if (!individual) {
            if(customerData.customer_streetAddress == '' || typeof customerData.customer_streetAddress == 'undefined') {
                modal.showInfo("We need the billing address.", "warning", "top", "center");
                return;
            }
            if(customerData.customer_city == '' || typeof customerData.customer_city == 'undefined') {
                modal.showInfo("We need the billing city.", "warning", "top", "center");
                return;
            }
            // if(customerData.customer_businessWebsite == '' || typeof customerData.customer_businessWebsite == 'undefined') {
            //     modal.showInfo("We need to know the primary owner\'s email.", "warning", "top", "center");
            //     modal.showDangerModal('Missing Information!', 'We need the business website.');
            //     return;
            // }
            //if(customerData.customer_company_type != 0 || customerData.customer_company_type != '0') {
            if(customerData.customer_ein == '' || typeof customerData.customer_ein == 'undefined' || customerData.customer_ein.length != 10) {
                modal.showInfo("We need the company EIN.", "warning", "top", "center");
                return;
            }
        // }
            if(customerData.customer_state == 0) {
                modal.showInfo("We need the billing state.", "warning", "top", "center");
                return;
            }
            if(customerData.customer_postalCode == '' || typeof customerData.customer_postalCode == 'undefined') {
                modal.showInfo("We need the billing zipcode.", "warning", "top", "center");
                return;
            }
        }
        if(customerData.customer_routing_number == '' || typeof customerData.customer_routing_number == 'undefined') {
            modal.showInfo("We need the routing number.", "warning", "top", "center");
            return;
        }
        if(customerData.customer_account_number == '' || typeof customerData.customer_account_number == 'undefined') {
            modal.showInfo("We need the account number.", "warning", "top", "center");
            return;
        }

        var prefix = 'http://';
        if (customerData.customer_businessWebsite.substr(0, prefix.length) !== prefix)
        {
            customerData.customer_businessWebsite = prefix + customerData.customer_businessWebsite;
        }

        // attach billing address to cardEvent
        var bankAccount = {
            country: 'us',
            currency: 'usd',
            routing_number: customerData.customer_routing_number,
            account_number: customerData.customer_account_number,
            account_holder_type: customerData.customer_bank_type,
            // billing information
            company_type: customerData.customer_company_type,
            name: customerData.customer_dba,
            address: customerData.customer_streetAddress,
            city: customerData.customer_city,
            state: customerData.customer_state,
            zip: customerData.customer_postalCode,
            dob: customerData.customer_dob,
            ein: customerData.customer_ein,
            email: customerData.customer_email,
            firstname: customerData.customer_firstname,
            lastname: customerData.customer_lastname,
            ownership: customerData.customer_ownership,
            phone: customerData.customer_phone,
            ssn: customerData.customer_ssn,
            business_website: '',//customerData.customer_businessWebsite,
            // owner
            title: customerData.customer_ownerTitle,
            owner_address: customerData.customer_ownerStreetAddress,
            owner_city: customerData.customer_ownerCity,
            owner_state: customerData.customer_ownerState,
            owner_zip: customerData.customer_ownerPostalCode,
            individual: individual
        };

        userBilling.saveAccountReceivable(bankAccount, function(response) {
            modal.showInfo("Great job!  Now you can start processing payments automatically.", "success", "top", "center");
            self.props.finishedForm();
        }, individual);
    }

    /* ACH Information */
    handleCustomerRoutingNumberChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_routing_number: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerAccountNumberChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_account_number: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerBankType(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_bank_type: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerCompanyType(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_company_type: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerNameChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_name: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerDBAChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_dba: {$set: e.target.value
                }}
            )
        });
    }

    handleAddressChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_streetAddress: {$set: e.target.value
                }}
            )
        });
    }

    handleCityChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_city: {$set: e.target.value
                }}
            )
        });
    }

    handleOwnerAddressChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_ownerStreetAddress: {$set: e.target.value
                }}
            )
        });
    }

    handleOwnerCityChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_ownerCity: {$set: e.target.value
                }}
            )
        });
    }

    handleOwnerTitleChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_ownerTitle: {$set: e.target.value
                }}
            )
        });
    }

    handleEinChange(e){
        var ein = einFormatter.format(e.target.value);
        this.setState({
            customerData: update(this.state.customerData, {
                customer_ein: {$set: ein
                }}
            )
        });
    }

    handleBusinessWebsiteChange(e) {
        this.setState({
            customerData: update(this.state.customerData, {
                customer_businessWebsite: {$set: e.target.value
                }}
            )
        });
    }

    handleStateChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_state: {$set: e.target.value
                }}
            )
        });
    }

    handleZipcodeChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_postalCode: {$set: e.target.value
                }}
            )
        });
    }

    handleOwnerStateChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_ownerState: {$set: e.target.value
                }}
            )
        });
    }

    handleOwnerZipcodeChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_ownerPostalCode: {$set: e.target.value
                }}
            )
        });
    }

    handleDobChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_dob: {$set: e.target.value
                }}
            )
        });
    }

    handleFirstnameChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_firstname: {$set: e.target.value
                }}
            )
        });
    }

    handleLastnameChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_lastname: {$set: e.target.value
                }}
            )
        });
    }

    handleEmailChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_email: {$set: e.target.value
                }}
            )
        });
    }

    handleOwnershipChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_ownership: {$set: e.target.value
                }}
            )
        });
    }

    handlePhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            customerData: update(this.state.customerData, {
                customer_phone: {$set: phoneNumber
                }}
            )
        });
    }

    handleSsnChange(e) {
        var ssn = ssnFormatter.format(e.target.value);
        this.setState({
            customerData: update(this.state.customerData, {
                customer_ssn: {$set: ssn
                }}
            )
        });
    }

    toggleForm(e) {
        this.setState({
            showForm: this.state.showForm ? false : true
        });
    }

    individualSelected() {
        this.setState({
            individualAccount: true,
        });
    }

    companySelected() {
        this.setState({
            individualAccount: false
        });
    }

    render(){
        const customerData = this.state.customerData;
        const individualAccount = this.state.individualAccount
        return (
            <div>
            <div class="row blue-bottom-margin">
            <div onClick={this.toggleForm.bind(this)}>
                <div class="content">
                    <form>
                    <div class="row">
                        <div class="col-md-2 col-sm-6 col-xs-12"></div>
                        <div class="col-md-4 col-sm-6 col-xs-12">
                            { individualAccount == true ? (
                            <div class="info-box selected-border" style={{cursor: 'pointer'}} onClick={this.individualSelected.bind(this)}>
                                <span class="info-box-icon blue-icon-circle" style={{paddingTop: '0px'}}><i class="icon-house-outline"></i></span>
                                <div class="info-box-content" style={{textAlign: 'center', verticalAlign: 'middle', lineHeight: '90px'}}>
                                    <span class="info-box-text">Individual</span>
                                </div>
                            </div>
                            ) : (
                            <div class="info-box" style={{cursor: 'pointer'}} onClick={this.individualSelected.bind(this)}>
                                <span class="info-box-icon blue-icon-circle" style={{paddingTop: '0px'}}><i class="icon-house-outline"></i></span>
                                <div class="info-box-content" style={{textAlign: 'center', verticalAlign: 'middle', lineHeight: '90px'}}>
                                    <span class="info-box-text">Individual</span>
                                </div>
                            </div>
                            )}
                        </div>
                        <div class="col-md-4 col-sm-6 col-xs-12">
                        { individualAccount == false ? (
                            <div class="info-box selected-border" style={{cursor: 'pointer'}} onClick={this.companySelected.bind(this)}>
                                <span class="info-box-icon blue-icon-circle" style={{paddingTop: '0px'}}><i class="icon-apartment-filled"></i></span>
                                <div class="info-box-content" style={{textAlign: 'center', verticalAlign: 'middle', lineHeight: '90px'}}>
                                    <span class="info-box-text">Company</span>
                                </div>
                            </div>
                        ) : (
                            <div class="info-box" style={{cursor: 'pointer'}} onClick={this.companySelected.bind(this)}>
                                <span class="info-box-icon blue-icon-circle" style={{paddingTop: '0px'}}><i class="icon-apartment-filled"></i></span>
                                <div class="info-box-content" style={{textAlign: 'center', verticalAlign: 'middle', lineHeight: '90px'}}>
                                    <span class="info-box-text">Company</span>
                                </div>
                            </div>
                        )}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="row">
                            <div class="header">
                                <span class="info-box-icon blue-icon-circle"><i class="icon-person-outline"></i></span>
                                <h4 class="title" style={{marginTop: '30px', marginLeft: '10px', float: 'left'}}>Primary Owner</h4>
                                <p class="category"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Firstname</label>
                                    <input type="text" value={customerData.customer_firstname} class="form-control tenant-info" name="firstname" placeholder="John" id="firstname" onChange={this.handleFirstnameChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">Lastname</label>
                                    <input type="text" value={customerData.customer_lastname} class="form-control tenant-info" name="lastname" placeholder="Doe" id="lastname" onChange={this.handleLastnameChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Email</label>
                                    <input type="text" value={customerData.customer_email} class="form-control tenant-info" name="email" placeholder="example@example.com" id="email" onChange={this.handleEmailChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">Address</label>
                                    <input type="text" value={customerData.customer_ownerStreetAddress} class="form-control tenant-info" name="dob" placeholder="Address" id="address" onChange={this.handleOwnerAddressChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                        <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">City</label>
                                    <input type="text" value={customerData.customer_ownerCity} class="form-control tenant-info" name="city" placeholder="City" id="city" onChange={this.handleOwnerCityChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <UnitedStatesSelect columnSize={0} sortID={customerData.customer_ownerState} title="State" onChange={this.handleOwnerStateChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Zipcode</label>
                                    <input type="text" value={customerData.customer_ownerPostalCode} class="form-control tenant-info" name="zipcode" placeholder="Zipcode" id="zipcode" onChange={this.handleOwnerZipcodeChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label>Phone</label>
                                    <input type="text" value={customerData.customer_phone} class="form-control tenant-info" name="phone" placeholder="Phone" id="phone" onChange={this.handlePhoneChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Date of Birth</label>
                                    <input type="date" value={customerData.customer_dob} class="form-control tenant-info" name="dob" placeholder="Date of Birth" id="dob" onChange={this.handleDobChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">SSN</label>
                                    <input type="text" value={customerData.customer_ssn} class="form-control tenant-info" name="ein" placeholder="SSN" id="ssn" onChange={this.handleSsnChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            { individualAccount == false ? (
                            <div>
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Ownership (%)</label>
                                    <input type="number" value={customerData.customer_ownership} class="form-control tenant-info" name="ownership" placeholder="50" id="ownership" onChange={this.handleOwnershipChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">Title</label>
                                    <input type="text" value={customerData.customer_ownerTitle} class="form-control tenant-info" name="title" placeholder="Title" id="title" onChange={this.handleOwnerTitleChange.bind(this)}/>
                                </div>
                            </div>
                            </div>
                            ) : (
                            <div>
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="dba">Doing Business As</label>
                                    <input type="text" value={customerData.customer_dba} class="form-control tenant-info" name="dba" placeholder="Example LLC" id="dba" onChange={this.handleCustomerDBAChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">Website</label>
                                    <input type="text" value={customerData.customer_businessWebsite} class="form-control tenant-info" name="business-website" placeholder="Company Website" id="business-website" onChange={this.handleBusinessWebsiteChange.bind(this)}/>
                                </div>
                            </div>
                            </div>
                            )}
                        </div>
                        { individualAccount == false && (
                        <div>
                        <div class="row">
                            <div class="header">
                                <span class="info-box-icon blue-icon-circle"><i class="icon-buildings"></i></span>
                                <h4 class="title" style={{marginTop: '30px', marginLeft: '10px', float: 'left'}}>Business Information</h4>
                                <p class="category"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="dba">Doing Business As</label>
                                    <input type="text" value={customerData.customer_dba} class="form-control tenant-info" name="dba" placeholder="Example LLC" id="dba" onChange={this.handleCustomerDBAChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">Company Type</label>
                                    <select class="form-control" value={customerData.customer_company_type} onChange={this.handleCustomerCompanyType.bind(this)}>
                                        <option value='1'>Corporation</option>
                                        <option value='2'>Limited Liability Company</option>
                                        <option value='3'>Partnership</option>
                                        <option value='4'>Association</option>
                                        <option value='5'>Non-Profit Organization</option>
                                        <option value='6'>Government Organization</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Business Website</label>
                                    <input type="text" value={customerData.customer_businessWebsite} class="form-control tenant-info" name="business-website" placeholder="Company Website" id="business-website" onChange={this.handleBusinessWebsiteChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">EIN</label>
                                    <input type="text" value={customerData.customer_ein} class="form-control tenant-info" name="ein" placeholder="EIN" id="ein" onChange={this.handleEinChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Address</label>
                                    <input type="text" value={customerData.customer_streetAddress} class="form-control tenant-info" name="dob" placeholder="Address" id="address" onChange={this.handleAddressChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">City</label>
                                    <input type="text" value={customerData.customer_city} class="form-control tenant-info" name="city" placeholder="City" id="city" onChange={this.handleCityChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <UnitedStatesSelect columnSize={0} sortID={customerData.customer_state} title="State" onChange={this.handleStateChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">Zipcode</label>
                                    <input type="text" value={customerData.customer_postalCode} class="form-control tenant-info" name="zipcode" placeholder="Zipcode" id="zipcode" onChange={this.handleZipcodeChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        </div>
                        )}
                        <div class="row">
                            <div class="header">
                                <span class="info-box-icon purple-icon-circle"><i class="pe-7s-culture"></i></span>
                                <h4 class="title" style={{marginTop: '30px', marginLeft: '10px', float: 'left'}}>Link Business Bank Account</h4>
                                <p class="category"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Routing Number</label>
                                    <input type="text" value={customerData.customer_routing_number} class="form-control tenant-info" name="routing" placeholder="Routing Number" id="routing" onChange={this.handleCustomerRoutingNumberChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">Account Number</label>
                                    <input type="text" value={customerData.customer_account_number} class="form-control tenant-info" name="account" placeholder="Account Number" id="account" onChange={this.handleCustomerAccountNumberChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Account Type</label>
                                    <select class="form-control" value={customerData.bank_type} onChange={this.handleCustomerBankType.bind(this)}>
                                        <option value='8'>Checking Account</option>
                                        <option value='9'>Savings Account</option>
                                        <option value='10'>Corporate Checking Account</option>
                                        <option value='11'>Corporate Savings Account</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    </form>
                </div>
                <div class="row">
                </div>
            </div>
            </div>
            <div class="row blue-bottom" style={{marginLeft:"-50px"}}>
                <div class="blue-bottom-center-align">
                    <div class="col-md-12">
                        <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.handleSaveACH.bind(this)}>
                        Create Account
                        </button>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// app/components/Billing/AccountReceivableForm.jsx